// 書類真贋判定
export type IDDocPassiveErrorCode =
  | 'dp_close'
  | 'dp_cropped'
  | 'dp_small'
  | 'dp_occluded'
  | 'dp_many_documents'
  | 'dp_low_quality'
  | 'dp_undefined';

export function extractDocPassiveErrorCode(codes: string[]): IDDocPassiveErrorCode | null {
  const code = codes.find((code) => code.includes('dp_'));
  if (code) {
    return code as IDDocPassiveErrorCode;
  }

  return null;
}
